import { FC } from 'react';
import styled from 'styled-components';
import useTheme from '../../utils/useTheme';
import { Avatar } from '../Avatar/Avatar';
import { Button } from '../Button/Button';

const SummaryRowElement = styled.div`
  display: grid;
  grid-template-areas:
    'avatar header button'
    'avatar subheader button';
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto;
  margin-bottom: 50px;
  transition: ${({ theme }) => theme.vars.transition.default};
`;

const AvatarArea = styled.div`
  margin: 0px 48px;
  align-self: center;
  grid-area: avatar;
`;

const SummaryRowHeader = styled.div`
  display: flex;
  grid-area: header;
  font-size: 24px;
  font-weight: 600;
  font-style: italic;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

const SummaryRowDescription = styled.div`
  display: flex;
  grid-area: subheader;
  font-size: 14px;
  margin-top: 13px;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

const ButtonArea = styled.div`
  grid-area: button;
  align-self: center;
  margin-right: 60px;
`;

export interface IProps {
  /** The heading of the summary row */
  heading: string;
  /** The description of the summary row */
  description: string;
  /** The text to show on the button of the summary row */
  buttonText: string;
  /** Function that fires when the button is clicked */
  onClick: () => void;
}

export const SummaryRow: FC<IProps> = props => {
  const theme = useTheme();

  return (
    <SummaryRowElement>
      <AvatarArea>
        <Avatar
          data-testid="Avatar"
          size="large"
          iconSize="extra-large"
          icon="check"
          bg={theme.vars.newColor.white}
          color={theme.vars.newColor.green2}
        />
      </AvatarArea>
      <SummaryRowHeader>{props.heading}</SummaryRowHeader>
      <SummaryRowDescription>{props.description}</SummaryRowDescription>
      <ButtonArea>
        <Button onClick={props.onClick}>{props.buttonText}</Button>
      </ButtonArea>
    </SummaryRowElement>
  );
};
